import { RELATION_HAS_PART } from '@backstage/catalog-model';
import {
  EntityRelationCard,
  type EntityColumnConfig,
  entityDataTableColumns,
} from '@backstage/plugin-catalog-react/alpha';

const aiResourceRelationColumns: EntityColumnConfig[] = [
  {
    ...entityDataTableColumns.createEntityRefColumn({
      defaultKind: 'AiResource',
    }),
    header: undefined,
    defaultWidth: '1fr',
    minWidth: 160,
    maxWidth: 240,
  },
  {
    ...entityDataTableColumns.createMetadataDescriptionColumn(),
    header: undefined,
    defaultWidth: '3fr',
    minWidth: 240,
  },
];

export const AiResourceHasPluginsCard = () => (
  <EntityRelationCard
    title="Has plugins"
    relationType={RELATION_HAS_PART}
    entityKind="AiResource"
    columnConfig={aiResourceRelationColumns}
    emptyState={{
      message: 'No plugins are available in this marketplace.',
    }}
  />
);

export const AiResourceHasSkillsCard = () => (
  <EntityRelationCard
    title="Has skills"
    relationType={RELATION_HAS_PART}
    entityKind="AiResource"
    columnConfig={aiResourceRelationColumns}
    emptyState={{
      message: 'No skills are included in this plugin.',
    }}
  />
);
